export default "__VITE_ASSET__DHfAcAp3__"